export default __webpack_public_path__ + "static/sweepstakes-prize-01-94704944fb17a35a0f5104186dfab584.jpg";